import { useRuntimeConfig } from "#imports";
export function useShouldLogMissingTranslationValue() {
  const config = useRuntimeConfig().public.i18n;
  return config.shouldLogMissingTranslationValue || false;
}
